import { useTranslation } from "react-i18next";
import { socialNetworks } from "../../data/contact-info";
import styled, { css } from "styled-components";
import { device } from "../../constants";

const StartButton = styled.a`
  display: flex;
  justify-content: center;
  align-self: center;
  align-items: center;
  gap: 8px;
  height: 48px;
  width: 342px;
  border-radius: 100px;
  transition: all 0.3s ease;
  background: ${({ theme }) => theme.colors["branding-02"]};
  font-size: 14px;
  letter-spacing: 1.4px;
  
  text-decoration: none;
  font-weight: 500;
  color: ${({ theme }) => theme.colors["neutral-01"]};
  
  &:hover {
    background: #7DAF2F;
    color: #FFF;
    text-decoration: none;
  }

  img {
    width: 20px;
    height: 20px;
  }

  @media ${device.laptop} {
    align-self: flex-start;
    width: 379px;
    height: 56px;
    font-size: 18px;
    letter-spacing: 1.8px;
    gap: 16px;
    line-height: 40px;

    img {
      width: 26px;
      height: 26px;
    }
  }

  ${({ ghost }) =>
		ghost &&
		css`
			background: transparent;
			color: ${({ theme }) => theme.colors["branding-02"]};
			border: 1px solid ${({ theme }) => theme.colors["branding-02"]};

      svg {
        transition: all 0.3s ease;
      }

      &:hover {
        path {
          fill: #fff!important;
        }
      }
		`}
`;

const WhatsappIcon = ({ ghost, ...props }) => (
	<svg
		width="24px"
		height="24px"
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
			<path
				d="M20.4054 3.4875C18.1607 1.2375 15.1714 0 11.9946 0C5.4375 0 0.101786 5.33571 0.101786 11.8929C0.101786 13.9821 0.654464 16.0179 1.70357 17.8071L0 24L6.32143 22.3286C8.03571 23.2875 9.99643 23.7857 11.9946 23.7857C18.5518 23.7857 23.8875 18.45 23.8875 11.8929C23.8875 8.71607 22.65 5.7375 20.4054 3.4875ZM11.9946 21.7875C10.2054 21.7875 8.45893 21.3107 6.93214 20.4161L6.57857 20.2071L2.84464 21.1875L3.84643 17.5446L3.61607 17.175C2.63571 15.5893 2.11607 13.7679 2.11607 11.8929C2.11607 6.43929 6.54107 2.01429 12 2.01429C14.6411 2.01429 17.1214 3.04821 18.9857 4.92321C20.85 6.79821 21.8839 9.27857 21.8839 11.8929C21.8732 17.3464 17.4482 21.7875 11.9946 21.7875ZM17.4214 14.3893C17.1321 14.2446 15.6696 13.5268 15.4018 13.4357C15.1339 13.3339 14.9357 13.2857 14.7375 13.5857C14.5393 13.8857 13.9714 14.5393 13.7946 14.7482C13.6179 14.9464 13.4411 14.9732 13.1518 14.8286C12.8625 14.6839 11.8929 14.3786 10.7518 13.3554C9.86786 12.5554 9.27857 11.5696 9.10179 11.2804C8.925 10.9911 9.08036 10.8304 9.22499 10.6804C9.35893 10.5464 9.51429 10.3286 9.66964 10.1518C9.825 9.975 9.87321 9.84643 9.975 9.64821C10.0768 9.45 10.0286 9.27321 9.95893 9.12857C9.88929 8.98393 9.30536 7.51607 9.05357 6.93214C8.80179 6.36429 8.54464 6.45 8.35714 6.44464C8.18036 6.43393 7.98214 6.43393 7.78393 6.43393C7.58571 6.43393 7.26429 6.50357 6.99643 6.79286C6.72857 7.08214 5.95714 7.80536 5.95714 9.27321C5.95714 10.7411 7.03393 12.1554 7.18929 12.3536C7.34464 12.5518 9.27857 15.5357 12.2357 16.8321C12.9536 17.1429 13.5161 17.3304 13.9607 17.4696C14.6893 17.7054 15.3536 17.6679 15.8786 17.5982C16.4625 17.5179 17.6357 16.8857 17.8875 16.2054C18.1393 15.525 18.1393 14.9464 18.0696 14.8286C18 14.7107 17.7107 14.6357 17.4214 14.3893Z"
				fill={!ghost ? "#FFFFFF" : "#6AB026"}
			/>
		</g>
	</svg>
);

export default function WhatsappStartChatButton({ ghost = false }) {
	const { t } = useTranslation();

	return (
		<StartButton href={socialNetworks.whatsapp()} ghost={ghost}>
			<WhatsappIcon ghost={ghost} />
			{t("blog.contactSection.startChat")}
		</StartButton>
	);
}
